import { render, staticRenderFns } from "./TemplatePreview.vue?vue&type=template&id=0846173b&scoped=true&"
import script from "./TemplatePreview.vue?vue&type=script&lang=js&"
export * from "./TemplatePreview.vue?vue&type=script&lang=js&"
import style0 from "./TemplatePreview.vue?vue&type=style&index=0&id=0846173b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0846173b",
  null
  
)

export default component.exports